import { useEffect } from 'react'
import { computeAddress } from 'ethers'
import Alert from 'react-bootstrap/Alert'
import Dropdown from 'react-bootstrap/Dropdown'
import CopyButton from '../shared/CopyButton'
import { formatAddress, formatBalance } from '../../utils/helpers'
import { useEnvironmentStore } from '../../zustand/environmentStore'
import { useWalletConfig } from '../../hooks/useWalletConfig'
import { RefreshButton } from './RefreshButton'
import { ManualWalletProps } from '../../types/props'
import { useUpdateEnvironment } from '../../hooks/useUpdateEnvironment'

const Manual = ({ client }: ManualWalletProps) => {
    const { privateKey, userKey, balance } = useEnvironmentStore()
    const { handleUpdateEnvironment } = useUpdateEnvironment()
    const { fileContents, loadWallets } = useWalletConfig(client)

    useEffect(() => {
        client.onload(loadWallets)
    }, [client])

    const computeFormattedAddress = (privateKey: string) => {
        if (!privateKey) return ''
        return formatAddress(computeAddress(privateKey))
    }

    return (
        <div className='manual-wallet-container'>
            <div className='public-key-heading-container'>
                <p>Account:</p>
                <RefreshButton onRefresh={loadWallets} />
                <CopyButton value={privateKey !== '' ? computeAddress(privateKey) : ''} />
            </div>

            <Dropdown>
                <Dropdown.Toggle size='sm' variant="secondary">
                    {computeFormattedAddress(privateKey)}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {Object.values(fileContents).map((item, index) => (
                        item.private_key && (
                            <Dropdown.Item
                                key={item.public_key}
                                onClick={() => handleUpdateEnvironment(
                                    item.public_key,
                                    item.private_key!,
                                    item.user_key
                                )}
                            >
                                {computeFormattedAddress(item.private_key)}
                            </Dropdown.Item>
                        )
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <p>Balance: {formatBalance(balance, 4)} COTI</p>

            {!userKey ? (
                <Alert variant='info' className='onboard-alert'>
                    Complete the Onboard procedure to generate your AES key
                </Alert>
            ) : (
                <div className='aes-key-container'>
                    <p>AES key: {userKey.substring(0, 4)}...{userKey.substring(userKey.length - 4)}</p>
                    <CopyButton value={userKey} />
                </div>
            )}
        </div>
    )
}

export default Manual